import { render, staticRenderFns } from "./similar-design.vue?vue&type=template&id=16097662&scoped=true"
import script from "./similar-design.vue?vue&type=script&lang=js"
export * from "./similar-design.vue?vue&type=script&lang=js"
import style0 from "./similar-design.vue?vue&type=style&index=0&id=16097662&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16097662",
  null
  
)

export default component.exports